import { Box, CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom";
import { SideBar } from "components/common/common";
import { useState } from "react";

const MainLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <CssBaseline />

      {/* Передаем состояние и колбэк в SideBar */}
      <SideBar
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {/* Основной контент с динамическими отступами */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: `calc(100% - ${sidebarCollapsed ? "60px" : "200px"})`,
          marginLeft: `${sidebarCollapsed ? "60px" : "210px"}`,
          transition: "margin-left 0.3s ease, width 0.3s ease",
          overflowY: "auto",
          height: "100vh",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
